<template>
  <dialog-v2
    :show="show"
    :title="title"
    max-width="400px"
    @close="$emit('close')"
    @save="save">
    <template v-if="pStage.id" slot="title">
      <v-icon class="delete-icon" @click.stop="deleteStage(pStage)" color="red" small>fas fa-trash-alt</v-icon>
    </template>
    <template slot="content">
      <v-layout row wrap>
        <v-flex>
          <v-text-field
            v-model="form.days_off"
            v-validate="'required|integer'"
            data-vv-name="days_off"
            data-vv-scope="pStage"
            data-vv-as="días antes del compromiso"
            label="Días antes del compromiso"
            color="black"
            :error-messages="errors.collect('pStage.days_off')"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    pStage: {
      type: Object,
      required: false,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      days_off: '',
    };
    return {
      emptyForm,
      form: {
        ...emptyForm,
      },
    };
  },
  computed: {
    title() {
      return `${!Object.keys(this.pStage).length ? 'Crear' : 'Editar'} etapa`;
    },
  },
  methods: {
    deleteStage(stage){
      this.$emit('delete-p-stage', stage);
    },
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, 'pStage');
      });
    },
    save() {
      this.$validator.validateAll('pStage').then((validation) => {
        if (validation) {
          if (Object.keys(this.pStage).length) {
            this.axios.patch(`payment_p_stages/${this.pStage.id}`, this.form)
              .then((response) => {
                this.$emit('updated', response.data);
                this.$emit('close');
              });
          } else {
            this.axios.post(`workflows/${this.$route.params.workflow}/payment_p_stages`, this.form)
              .then((response) => {
                this.$emit('created', response.data);
                this.$emit('close');
              })
              .catch(() => {});
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.form = _.pick({
          ...this.emptyForm,
          ...this.pStage,
        }, Object.keys(this.emptyForm));
        this.clearErrors();
      } else {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          this.clearErrors();
        }, 200);
      }
    },
  },
};
</script>

<style scoped>
.delete-icon:hover {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/PaymentPromiseTree/PStageModal.vue